<template>
    <v-card>
        <v-card-title class="accent white--text title">
            Chiller Staging Profile
        </v-card-title>
        <v-card-text>
            <date-range-selector v-model="range"></date-range-selector>
        </v-card-text>
        <v-card-text>
            <v-layout class="grey--text caption">
                <loading-progress-bar :loading="loading"></loading-progress-bar>
                <v-spacer></v-spacer>
                <span>{{facility_name}}</span>
            </v-layout>
        </v-card-text>
        <v-card-text v-if="!loading">
            <vue-plotly :data="data" :layout="layout" :options="options"/>
        </v-card-text>
    </v-card>
</template>

<script>
import VuePlotly from '@/components/VuePlotly'
import {callAPI} from '@/helper'
import DateRangeSelector from './DateRangeSelector'
import LoadingProgressBar from './LoadingProgressBar'
import moment from 'moment'

  export default {
    name: 'StagingProfile',
    components: {
      LoadingProgressBar,
      DateRangeSelector,
      VuePlotly

    },
    data() {
      return {
        loading: true,
        range: {start:moment().subtract(30, "days").format("YYYY-MM-DD"),end:moment().format("YYYY-MM-DD")},
          timeout:null,
        data:[],
        layout: {
          hovermode: 'closest',
          xaxis: { title: 'Cooling Load (kW)' },
          yaxis: { title: 'COP' }
        },
        options: {},
      }
    },
    watch: {
      range () {
        this.refresh()
      }
    },
    computed: {
      facility_name () {
        return this.$store.state.pointsListStore.pointsList.facility_name
      }
    },
     mounted () {
      this.refresh()
    },
    methods: {
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout= setTimeout(() => callback(), wait);
        },
        refresh(){
            this.debounce(this.doRefresh,200);
        },
      async doRefresh(){
        this.loading = true
          let chillers=[]
          for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
              let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
              if(equip.equipment_type.toLowerCase().startsWith('chiller')){
                  let allSensors=this.$store.state.pointsListStore.pointsList.sensors[i]
                  if(allSensors.indexOf("Cooling_Load")>-1){
                      chillers.push(equip.equipment_name)
                  }
              }
          }
          let param = {
            'facility_name': this.facility_name,
            'equipment_names': chillers,
            'date_range': [this.range.start, this.range.end]
          }
          let res = await callAPI('stagingprofile/',
            param
          )
          let df = res.data.result
          let output = []

          for (let i in df) {
              let mydf=df[i];
              for (let index in mydf.COP){
                  if(mydf.COP[index]>20){
                      delete(mydf.COP[index])
                      delete(mydf.Cooling_Load[index])
                  }
              }
            output.push({
              'y': mydf.COP, 'x': mydf.Cooling_Load, type: 'scattergl', mode: 'markers', 'name':i}
              )
          }

          this.data = output
        this.loading = false
      },
        beforeMount() {
            let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
            if(maxDate){
                this.range={start:moment(maxDate).subtract(30, "days").format('YYYY-MM-DD'),end:moment(maxDate).format('YYYY-MM-DD')}
            }
        }
    }
  }
</script>

<style scoped>

</style>
